import { render, staticRenderFns } from "./renew.vue?vue&type=template&id=c5f738c6&"
import script from "./renew.vue?vue&type=script&lang=ts&"
export * from "./renew.vue?vue&type=script&lang=ts&"
import style0 from "./renew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports